import api from '../utils/api';

// Fetch all teacher histories
export const getAllTeacherHistories = async (headers) => {
  try {
    const response = await api.get('/api/teacherHistory', headers);
    console.log("getAllTeacherHistories", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching all teacher histories:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific teacher history by ID
export const getTeacherHistoryById = async (id, headers) => {
  try {
    const response = await api.get(`/api/teacherHistory/${id}`, headers);
    console.log("get one teacher Histories by id", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher history by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update teacher history by ID
export const updateTeacherHistory = async (id, teacherHistoryData, headers) => {
  try {
    const response = await api.put(`/api/teacherHistory/${id}`, teacherHistoryData, headers);
    return response.data;
  } catch (error) {
    console.error('Error updating teacher history:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete teacher history by ID
export const deleteTeacherHistory = async (id, headers) => {
  try {
    const response = await api.delete(`/api/teacherHistory/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error deleting teacher history:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch teacher histories by teacherId
export const getTeacherHistoryByTeacherId = async (teacherId, headers) => {
  try {
    const response = await api.get(`/api/teacherHistory/teacher/${teacherId}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher history by teacher ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};